// useActionsSubmit.ts
import { userInfoQueryOptions } from '@/common/queries/userInfo/userInfoQueryOptions';
import useBackForCorrectionActionMutation from '@/modules/FileDetail/hooks/useBackForCorrectionActionMutation';
import useMoveToInprogressActionMutation from '@/modules/FileDetail/hooks/useMoveToInprogressActionMutation';
import useReferToBranchActionMutation from '@/modules/FileDetail/hooks/useReferToBranchActionMutation';
import useSendToBranchActionMutation from '@/modules/FileDetail/hooks/useSendToBranchActionMutation';

import { ActionsFormDataType } from '@/modules/FileDetail/types/actionsFormData';
import { useQuery } from '@tanstack/react-query';

export const useActionsSubmit = (
  id: string,
  openSignatureModal: () => void,
) => {
  const { data: userInfo } = useQuery(userInfoQueryOptions());
  const { mutate: sendToBranch, isPending: isSendToBranchPending } =
    useSendToBranchActionMutation(id);
  const { mutate: backForCorrection, isPending: isBackForCorrectionPending } =
    useBackForCorrectionActionMutation(id);
  const { mutate: referToBranch, isPending: isReferToBranchPending } =
    useReferToBranchActionMutation(id);

  const { mutate: moveToInProgress, isPending: isMoveToInProgressPending } =
    useMoveToInprogressActionMutation(id);

  const onSubmit = (data: ActionsFormDataType) => {
    const payload = {
      description: data?.description,
    };

    if (!userInfo?.has_signature && data.action === 'send_to_branch') {
      openSignatureModal();
    } else {
      switch (data.action) {
        case 'send_to_branch':
          sendToBranch(payload);
          break;
        case 'back_for_correction':
          backForCorrection(payload);
          break;
        case 'refer_to_branch':
          referToBranch(payload);
          break;
        case 'move_to_in_progress':
          moveToInProgress(payload);
          break;
      }
    }
  };

  const isLoading =
    isSendToBranchPending ||
    isBackForCorrectionPending ||
    isReferToBranchPending ||
    isMoveToInProgressPending;

  return { onSubmit, isLoading };
};
